const STOP_WORDS = new Set([
  // Articles, pronouns, prepositions, conjunctions, determiners
  'the','be','to','of','and','a','in','that','have','i','it','for','not','on','with',
  'he','as','you','do','at','this','but','his','by','from','they','we','say','her',
  'she','or','an','will','my','one','all','would','there','their','what','so','up',
  'out','if','about','who','get','which','go','me','when','can','like','no','him',
  'some','your','only','even','much','own','such','every','any','few','most','more',
  'them','see','other','than','then','now','its','over','also','back','after',
  'how','our','any','these','us','are','was','were','been','has','had','did',
  'got','may','said','does','those','own','too','into','through','during',
  'before','between','both','each','few','against','because','until','while',
  'above','below','again','further','once','nor','such','since','although',
  'though','whether','either','neither','another','without','within','along',
  'among','around','toward','towards','upon','whose','whom','enough','rather',
  'across','behind','beside','besides','beyond','despite','except','onto',
  'per','plus','versus','via','under','near','off','till',

  // Contractions (apostrophes stripped by tokenizer, so "it's" → "its", "don't" → "dont")
  'dont','thats','youre','ive','theyre','hes','shes','youve','weve',
  'theyd','youd','wed','ill','youll','theyll','hell','shell','isnt','arent','wasnt',
  'werent','hasnt','havent','hadnt','doesnt','didnt','wont','wouldnt','cant','couldnt',
  'shouldnt','might','must','shall','dare','im','lets','whats','heres','theres',
  'itll','wholl','thatll','therell','itd','mustnt','mightnt','neednt','shant',
  'whos','whys','hows','whens','wheres',

  // Filler words common in spoken YouTube transcripts
  'um','uh','ah','oh','like','just','know','think','mean','want','gonna','gotta',
  'yeah','yes','okay','right','well','actually','basically','literally','really',
  'very','pretty','quite','totally','completely','absolutely','definitely','probably',
  'maybe','perhaps','anyway','anyways','honestly','seriously','obviously','clearly',
  'simply','exactly','especially','particularly','apparently','essentially',
  'certainly','surely','truly','merely','nearly','hardly','roughly',
  'hopefully','fortunately','unfortunately','naturally','eventually',
  'finally','ultimately','effectively','personally','generally','typically',

  // Generic verbs (too vague for titles)
  'make','take','give','come','put','let','keep','set','run','try','ask','move',
  'made','find','look','tell','show','turn','leave','call','start','seem','help',
  'talk','hold','bring','happen','write','sit','stand','lose','pay','meet','play',
  'begin','end','open','close','cut','stop','feel','pick','pass','watch','wait',
  'hear','follow','allow','include','continue','change','lead','became','become',
  'went','done','goes','gave','seen','taken','left','sent','read','live','lives',
  'lived','gone','came','used','means','meant','believe','understand','remember',
  'consider','realize','suppose','imagine','wonder','guess','figure','notice',
  'mention','explain','add','added','goes','stay','stayed','cause','caused',
  'need','should','could','would','going','being','doing','having','getting',
  'looking','making','taking','coming','saying','using','working','trying',
  'thinking','talking','telling','putting','seeing','knowing','giving',
  'running','playing','calling','starting','happening','keeping','turning',
  'leaving','sitting','standing','moving','asking','feeling','showing',
  'following','bringing','holding','leading','helping','meeting','writing',
  'paying','losing','hearing','speaking','building','reading','learning',
  'pulling','pushing','wearing','breaking','sending','falling','growing',
  'spending','buying','selling','eating','sleeping','walking','driving',
  'carrying','checking','creating','letting','picking','setting','waiting',
  'watching','living','becoming','lying','dying','fighting','hitting','running',

  // Generic adjectives/adverbs (don't help titles)
  'good','great','big','small','long','little','much','many','more','most',
  'new','old','first','last','next','same','different','whole','kind',
  'lot','thing','things','stuff','way','ways','part','point','fact','sort',
  'able','sure','real','true','full','high','low','bad','hard','easy',
  'early','late','likely','possible','important','interesting','specific',
  'certain','clear','similar','available','common','entire','previous',
  'main','major','various','possible','recent','single','super',

  // Time/quantity fillers
  'time','times','day','days','year','years','today','tomorrow','yesterday',
  'always','never','ever','every','still','already','often','sometimes',
  'people','person','something','anything','everything','nothing','someone',
  'everyone','somewhere','here','there','where','down',
  'week','weeks','month','months','hour','hours','minute','minutes',
  'second','seconds','number','half','couple','several','less','least',
  'twice','ago','later','earlier','soon','recently','currently','moment',
  'tonight','morning','afternoon','evening','usually','rarely','frequently',

  // Connectors and discourse markers common in speech
  'also','however','therefore','furthermore','moreover','meanwhile',
  'otherwise','instead','nevertheless','nonetheless','hence','thus',
  'consequently','accordingly','regardless','whereas','whereby',

  // Demonstratives and relative words
  'itself','myself','yourself','himself','herself','themselves','ourselves',
  'yourselves','whatnot','whatever','wherever','whenever','whoever','whichever',

  // Transcript artifacts
  'music','applause','laughter','cheering','inaudible','subscriber','subscribers',
]);

export default STOP_WORDS;
